import React from 'react'
import PropTypes from 'prop-types'
import TextField from './TextField'
import Component from './Component'

export default class LabeledTextField extends Component {
  static propTypes = {
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
    type: PropTypes.string,
    fieldName: PropTypes.string,
    disabled: PropTypes.bool,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    cssClasses: PropTypes.string,
    inputCssClass: PropTypes.string,
    labelCssClass: PropTypes.string,
    placeholder: PropTypes.string,
    defaultValue: PropTypes.string
  }

  static renderedProps = [
    'label',
    'name',
    'type',
    'errorMessage',
    'value',
    'fieldName',
    'disabled',
    'min',
    'max',
    'step',
    'title',
    'placeholder',
    'defaultValue'
  ]

  render() {
    const {
      label, name, handleChange, handleBlur,
      errorMessage, value, cssClasses, inputCssClass,
      type, fieldName, disabled, min, max, step,
      placeholder, defaultValue, labelCssClass
    } = this.props

    const title = this.props.title || label

    return (
      <div id={name} className={cssClasses}>
        <label>
          <div className={labelCssClass}>{label}</div>
          <TextField
            name={name}
            title={title}
            type={type}
            fieldName={fieldName}
            handleChange={handleChange}
            handleBlur={handleBlur}
            errorMessage={errorMessage}
            value={value}
            disabled={disabled}
            inputCssClass={inputCssClass}
            min={min}
            max={max}
            step={step}
            placeholder={placeholder}
            defaultValue={defaultValue}
          />
        </label>
      </div>
    )
  }
}
